/* Disponibilité de Jira pour la session (arbitrage du 06/10/2026) : le premier appel sert de test.
   Les autres attendent sa réponse ; si Jira est mal configuré (secrets manquants), plus aucun appel
   ne part jusqu'à un « Actualiser » explicite. Au niveau du module : `api` est recréé à chaque
   rendu. */
let probe = null; // { promise, done } tant que l'appel test est en cours
let probed = false; // l'appel test a répondu pendant la session
let unavailableReason = null;

// Synchrone, pour que des appels lancés au même instant ne passent pas tous : le premier appelant
// devient le test (null) ; les autres reçoivent une promesse résolue quand le test a répondu.
export function joinProbe() {
  if (probed) return Promise.resolve();
  if (probe) return probe.promise;
  let done;
  probe = { promise: new Promise((resolve) => (done = resolve)), done };
  return null;
}

export function endProbe() {
  probed = true;
  probe?.done();
  probe = null;
}

export const jiraUnavailableReason = () => unavailableReason;

export function recordJiraError(message) {
  if (/Secrets Jira manquants/.test(message || '')) unavailableReason = message;
}

// « Actualiser » : on retente Jira, même s'il était indisponible.
export function resetJiraAvailability() {
  probe?.done();
  probe = null;
  probed = false;
  unavailableReason = null;
}
